import React, { forwardRef } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import PropTypes from "prop-types";

const BasicDateTimePicker = forwardRef(
  ({ label, onErrorCheck, control, name, ...props }, ref) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DateTimePicker
              onChange={onChange}
              format="DD/MM/YYYY hh:mm A"
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  //   padding: "8px",
                  //   height: "45px",
                  fontSize: "16px",
                  borderRadius: "25px",
                  color: "black", // Set the input text color to black
                  backgroundColor: "white", // Set background color to white
                  "& fieldset": {
                    borderColor: "#ccc", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "#999", // Border color on hover
                  },
                  // "&.Mui-focused fieldset": {
                  //   borderColor: "transparent", // Border color on focus
                  //   outline: "none", // Remove outline on focus
                  // },
                },
              }}
              slotProps={{
                textField: {
                  helperText: onErrorCheck ? onErrorCheck : "",
                  error: Boolean(onErrorCheck),
                },
                field: { clearable: true },
              }}
              value={value ? dayjs(value) : null} // Parse string into dayjs object
            />
          )}
        />
      </LocalizationProvider>
    );
  }
);

BasicDateTimePicker.propTypes = {
  label: PropTypes.string,
  onErrorCheck: PropTypes.string,
  control: PropTypes.object.isRequired, // `control` is required for react-hook-form
  name: PropTypes.string.isRequired, // `name` is required for react-hook-form
};

export default BasicDateTimePicker;
